import React, { useEffect, useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockIcon from '@material-ui/icons/Lock';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import { Alert } from '@material-ui/lab'
import config from '../config';
import { Redirect } from 'react-router-dom';
import { FormControl, InputLabel, OutlinedInput } from '@material-ui/core';
import { Copyright } from './Copyright';

const useStyles = makeStyles((theme:any) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    
  },
}));



export default function SignIn() {
  const classes = useStyles();
  const [jwt, setJWT] = useState<string>("");
  const [invalidLogin, setInvalidLogin] = useState<Boolean>(false);
  const [showPassword, setShowPassword] = useState<Boolean>(false);
  const [password, setPassword] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");

  useEffect (() => {
    console.log("New JWT", jwt);
  },[jwt])

  const handleMouseDownPassword = (event:any) => {
    event.preventDefault();
  };

  const handlePwdChange = (event:any) => {
    setPassword(event.target.value);
  };

  const handleEmailChange = (event:any) => {
    setEmail(event.target.value);
  };

  const login = async (evt:any) => {
      evt.preventDefault();
      console.log("Logging in");
      const response = await fetch(config.BACKEND_URL + 'login', {
        method: 'post',
        headers: {
          'Content-type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          password: password
        }),
      });
      const responseBody = await response.json();
      if(responseBody.usrloggedin){
        setJWT(responseBody.Token);
        console.log("Successfully logged in");
      }
      else{
        setInvalidLogin(true);
        console.log("Invalid email/password provided");
        setErrorMessage("Ugyldig epost eller passord");
      }
  }

  if(jwt!=""){
    return (
      <Redirect
      to={{
        pathname: '/dashboard/' + jwt,
      }}
    />
    );
  }
else{
  return (


    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockIcon />
        </Avatar>
        {(errorMessage!=="" && 
          <Alert severity="error">{errorMessage}</Alert>
        )}
        <Typography component="h1" variant="h5">
          Logg inn
        </Typography>
        <form className={classes.form} onSubmit={login}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="E-post adresse"
            value={email}
            onChange={handleEmailChange}
            name="email"
            autoComplete="email"
            autoFocus
          />
          <FormControl fullWidth className={classes.textField} variant="outlined">
          <InputLabel htmlFor="outlined-adornment-password">Passord*</InputLabel>
          <OutlinedInput
            id="outlined-adornment-password"
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={handlePwdChange}
            fullWidth
            required
            autoComplete="current-password"
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => {setShowPassword(!showPassword)}}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
            labelWidth={70}
          />
          </FormControl>
          <FormControlLabel
            control={<Checkbox value="remember" color="primary" />}
            label="Husk meg"
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            type="submit"
          >
            Logg inn
          </Button>
          <Grid container>
            <Grid item xs>
              <Link href="/renewpassword" variant="body2">
                Glemt passord?
              </Link>
            </Grid>
            <Grid item>
              <Link href="/signup" variant="body2">
                {"Har du ikke konto? Registrer deg her"}
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
  }
}